import React from 'react'

export const Cuimhne = () => {
  return (
    <div>More details to come...</div>
  )
}
